import { MakeCall } from './createMakeCall';
import { APIV2_URL } from './constants';
import { VideoUrlList } from './types/Listing';

export type AddYoutubeVideoCall = (
  listingId: number,
  youtubeId: string,
) => Promise<{ data: VideoUrlList[] }>;

export default (makeCall: MakeCall) => (
  listingId: number,
  youtubeUrl: string,
) =>
  makeCall<VideoUrlList[]>(
    'POST',
    `${APIV2_URL}/listing/${listingId}/youtube-video`,
    { data: { youtubeUrl } },
  );
